import { getIdToken, isTokenExpired, refreshTokens, logout } from "./auth";

const TASKS_URL    = process.env.REACT_APP_API_URL || "/api/tasks";
const SETTINGS_URL = TASKS_URL.replace("/tasks", "/settings");

async function getAuthHeader() {
  if (isTokenExpired()) await refreshTokens();
  const token = getIdToken();
  if (!token) throw new Error("Not authenticated");
  return { Authorization: `Bearer ${token}` };
}

async function request(method, url, body = null) {
  const auth = await getAuthHeader();
  const opts = {
    method,
    headers: { "Content-Type": "application/json", ...auth },
  };
  if (body) opts.body = JSON.stringify(body);

  const res = await fetch(url, opts);

  if (res.status === 401 || res.status === 403) {
    logout();
    window.location.reload();
    throw new Error("Session expired — please log in again");
  }

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || data.errors?.join(", ") || "Unknown error");
  return data;
}

export const api = {
  // Tasks
  listTasks:   (status) => request("GET", TASKS_URL + (status ? `?status=${status}` : "")),
  createTask:  (task)   => request("POST", TASKS_URL, task),
  getTask:     (id)     => request("GET", `${TASKS_URL}/${id}`),
  updateTask:  (id, u)  => request("PUT", `${TASKS_URL}/${id}`, u),
  deleteTask:  (id)     => request("DELETE", `${TASKS_URL}/${id}`),

  // Settings
  getSettings:       ()            => request("GET",  SETTINGS_URL),
  putSettings:       (body)        => request("PUT",  SETTINGS_URL, body),
  getPhotoUploadUrl: (contentType) => request("POST", `${SETTINGS_URL}/photo`, { content_type: contentType }),
};
